import BrButton from '@govbr/react-components/lib/BrButton';
import { Dialog, DialogContent, Grid } from '@material-ui/core';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'underscore';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import imgConsultaCpf from '../../assets/img/ico-file-cpf.svg';
import auth from '../../auth/Auth';

import {
  authLogout,
  limparAuth,
  loginGateway,
  selectGateway,
} from '../../auth/authSlice';
import * as mensagens from '../../common/Mensagens';
import { trackServiceSelect } from '../../common/tracker';
import Accordion, { SCROLL_OFFSET_NAV_FIXED } from '../../components/Accordion/Accordion';
import AjudaRapida from '../../components/AjudaRapida/AjudaRapida';
import BotaoServico from '../../components/BotaoServico/BotaoServico';
import Card from '../../components/Card/Card';
import DadosBasicos from '../../components/DadosBasicos/DadosBasicos';
import LoadingGlobal from '../../components/LoadingGlobal/LoadingGlobal';
import MainContainer from '../../components/MainContainer/MainContainer';
import Message from '../../components/Message/Message';
import { limpar as limparConsultaRenda } from '../../features/ConsultaRenda/consultaRendaSlice';
import { selectLoggingIn, setLoggingIn } from '../../globalSlice';
import { SituacaoCadastroFamiliaUsuario } from '../../model/SituacaoCadastroFamiliaUsuario';
import { limparDadosFamilia } from '../ConsultaSimples/consultaSimplesSlice';
import {
  getPerfis,
  getPermiteRemoverFamiliaCadUnico,
  getSituacaoCadastroFamilia,
  limparPerfil,
  selecionarNumeroFamiliar,
  selecionarPerfil,
  selecionarTipoPerfil,
  selectPerfilCompleto,
  selectPerfis,
  selectPermiteRemoverFamiliaCadUnico,
  selectSelecionouSolicitacaoCadastramento,
  selectSituacaoCadastroFamilia,
  setBuscandoPerfis,
} from '../Perfil/perfilSlice';
import { selectTemTermoAssinado } from '../TermoDeUso/termoDeUsoSlice';
import styles from './Home.module.css';
import logoCadastroUnico from '../../assets/img/logo-cadunico-web.png';

import * as Mensagens from '../../common/Mensagens';
import { calcularTempoRestanteDecursoPrazo } from '../../common/DateUtil';
import { selectDadosPreFamilia } from '../PreCadastro/ConsultaPreCadastro/consultaPreCadastroSlice';
import { selectMostrarModalPendencias, setMostrarModalPendencias } from '../ConsultaPendencias/consultaPendenciasSlice';
import { getIntegrantesIndicativoNascimento, jaConsultadoIndicativoNascimento, marcarConsultadoIndicativoNascimento } from '../IndicativoNascimento/indicativoNascimentoSlice';
import { obterNomeDoPerfil, obterNomeDoPerfilComum } from '../../common/perfilUtils';
import { getDecursoPrazo, selectDecursoPrazo,selectVersaoMinimaAceitavel } from '../Suporte/SuporteSlice';
import configuration from '../../envConfig';
import useConnectionStatus from '../../common/ConnectionStatus/ConnectionStatus';
import InternetConnectionError from '../../components/ConnectionStatus/ConnectionError';
import useApiStatus from '../../common/ApiStatus/ApiStatus';
import ApiConnectionError from '../../components/ApiStatus/ApiError';
import { TipoPerfil } from '../../model/TipoPerfil';
import { TipoMensagemBanner, selectBannerInfo } from '../../components/DadosBasicos/dadosBasicosSlice';

export const mostrarConsultaSimples = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "DADOS RESUMIDOS DA FAMÍLIA");
  history.push('/consultaSimples');
};

export const mostrarConsultaPendencias = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "PENDÊNCIAS DO CADASTRO");
  history.push('/consulta-pendencias');
};

export const mostrarConsultaCpf = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "CONSULTA POR CPF");
  history.push('/consultaCpf');
};

export const mostrarConsultaCompleta = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "CONSULTA AO FORMULÁRIO");
  history.push('/consultaCompleta');
};

export const mostrarConsultaRenda = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "CONSULTA RENDA");
  if (localStorage.getItem('cadunico/tutorial-consulta-renda-nao-exibir') === 'true') {
    history.push('/consultaRenda');
  } else {
    history.push('/consultaRenda/tutorial');
  }
};

export const mostrarConsultaEscolaridade = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "CONSULTA ESCOLARIDADE ATUALIZADA");
  if (localStorage.getItem('cadunico/tutorial-consulta-escolaridade-nao-exibir') === 'true') {
    history.push('/consultaEscolaridade');
  } else {
    history.push('/consultaEscolaridade/tutorial');
  }
};

export const mostrarPreCadastro = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "SOLICITAÇÃO DE CADASTRAMENTO");
  history.push('/preCadastro');
};

export const mostrarSelecaoUFCriseRS = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "SELEÇÃO RS CRISE");
  history.push('/selecaoUFCriseRS');
};

export const mostrarComprovante = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "EMISSÃO DE COMPROVANTE");
  history.push('/comprovante');
};

export const mostrarAtualizacaoCadastralPorConfirmacao = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "ATUALIZAÇÃO CADASTRAL POR CONFIRMAÇÃO");
  history.push('/atualizacaoCadastralPorConfirmacao');
};

export const mostrarValidacaoComprovante = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "VALIDAÇÃO COMPROVANTE");
  history.push('/validacao-comprovante');
};

export const mostrarCarteiraDocumentos = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "CARTEIRA DE DOCUMENTOS");
  if (localStorage.getItem('cadunico/aviso-carteira-documentos-nao-exibir') === 'true') {
    history.push('/carteira-documentos');
  } else {
    history.push('/aviso-carteira-documentos');
  }
};

export const mostrarPostosAtendimento = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "POSTOS DE ATENDIMENTO");
  history.push('/posto-atendimento');
};

export const mostrarMeusBeneficios = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "MEUS BENEFÍCIOS");
  history.push('/painelBeneficios');
};

export const mostrarTermoDeUso = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  history.push('/termo-de-uso');
};

export const mostrarProgramasSociais = (history) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "PROGRAMAS SOCIAIS");
  history.push('/programas-sociais');
};

export const mostrarExclusaoCadastralTutorial = (history, exibirApenasTutorial) => {
  localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');
  trackServiceSelect('POR-MENU', "EXCLUSÃO CADASTRAL TUTORIAL");

  localStorage.setItem('cadunico/redirect', '/exclusaoCadastral/tutorial');

  if (exibirApenasTutorial) {
    localStorage.setItem('enviar-para-home', 'true');
  } else {
    localStorage.setItem('enviar-para-home', 'false');
  }

  history.push('/exclusaoCadastral/tutorial');
};

const Home: React.FC = () => {
  const apiStatus = useApiStatus();
  const [apiError, setApiError] = useState(false);
  const connectionStatus = useConnectionStatus();
  const [connectionError, setConnectionError] = useState(false);

  const dispatch = useAppDispatch();
  const history = useHistory();

  const perfis = useAppSelector(selectPerfis);
  const perfil = useAppSelector(selectPerfilCompleto);
  const gatewayLogado = useAppSelector(selectGateway).logado;

  const temTermoAssinado = useAppSelector(selectTemTermoAssinado);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const permiteRemoverFamiliaCadUnico = useAppSelector(selectPermiteRemoverFamiliaCadUnico);
  const loggingIn = useAppSelector(selectLoggingIn);
  const dadosPreFamilia = useAppSelector(selectDadosPreFamilia);

  const mostrarModalPendencias = useAppSelector(selectMostrarModalPendencias);
  const bannerInfo = useAppSelector(selectBannerInfo);
  const rfTemIndicativoObito = bannerInfo?.tipoMensagemBanner?.codigo === TipoMensagemBanner.RF_INDICATIVO_OBITO_REGULAR_PENDENCIA;

  const PERMITE_PRE_CADASTRO_USUARIO = situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario !== SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_CADASTRADA;

  const FAMILIA_NAO_CADASTRADA = situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario !== SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_CADASTRADA;

  const selecionouSolicitacaoCadastramento = useAppSelector(selectSelecionouSolicitacaoCadastramento);

  const [ popupIntervalId, setPopupIntervalId ] = useState(undefined as any);

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  const temVersaoMinimaAceitavel = useAppSelector(selectVersaoMinimaAceitavel);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  },[]);

  useEffect(() => {
    const cpf = auth.getUser();
    const deveConsultarIndicativoNascimento =
      cpf &&
      !jaConsultadoIndicativoNascimento(cpf) &&
      perfil?.numeroFamiliar &&
      perfil?.tipoPerfil?.codigo === TipoPerfil.RESPONSAVEL_FAMILIAR &&
      perfil?.tipoEstadoCadastralFamilia?.codigo === 3;

    if (deveConsultarIndicativoNascimento) {
      marcarConsultadoIndicativoNascimento(cpf);
      dispatch(getIntegrantesIndicativoNascimento(String(perfil.numeroFamiliar)))
        .unwrap()
        .then((result) => {
          if (result?.integrantesIndicativoNascimento?.length > 0) {
            history.push('/indicativo-nascimento');
          }
        })
        .catch(() => { });
    }
  }, [dispatch, perfil?.numeroFamiliar]);

  useEffect(() => {
    dispatch(limparConsultaRenda());

    if (gatewayLogado && (!temTermoAssinado || !perfil)) {
      localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');

      if (!situacaoCadastroFamilia) {
        dispatch(getSituacaoCadastroFamilia({ cpf: auth.getUser(), history }));
        return;
      }

      if (localStorage.getItem('cadunico/redirect') !== '/preCadastro' &&
        PERMITE_PRE_CADASTRO_USUARIO &&
        !situacaoCadastroFamilia?.temRL
        ) {
          localStorage.removeItem('cadunico/redirect');

          history.push('/home');
          return;
      }

      if (localStorage.getItem('cadunico/redirect') === '/atualizacaoCadastralPorConfirmacao') {
        localStorage.removeItem('cadunico/redirect');

        history.push('/atualizacaoCadastralPorConfirmacao');
        return;
      }

      if (localStorage.getItem('cadunico/redirect') === '/exclusaoCadastral/tutorial') {
        localStorage.removeItem('cadunico/redirect');

        history.push('/exclusaoCadastral/tutorial');
        return;
      }

      if (localStorage.getItem('cadunico/redirect') === '/painelBeneficios') {
        localStorage.removeItem('cadunico/redirect');

        history.push('/painelBeneficios');
        return;
      }

      if (localStorage.getItem('cadunico/redirect') === '/consultaCompleta') {
        localStorage.removeItem('cadunico/redirect');

        history.push('/consultaCompleta');
        return;
      }

      if (localStorage.getItem('cadunico/redirect') === '/consultaRenda') {
        localStorage.removeItem('cadunico/redirect');
        dispatch(limparConsultaRenda());

        history.push('/consultaRenda');
        return;
      }

      if (localStorage.getItem('cadunico/redirect') === '/preCadastro') {
        localStorage.removeItem('cadunico/redirect');

        history.push('/preCadastro');
        return;
      }
    }

    return () => {
      dispatch(limparConsultaRenda());
    }
  }, [gatewayLogado, temTermoAssinado, perfil, PERMITE_PRE_CADASTRO_USUARIO, situacaoCadastroFamilia, history, dispatch]);

  const tiposPerfil = useCallback(() => {
    if (!perfis) {
      return [];
    }
    return Object.keys(
      _.groupBy(perfis, function (perfil) {
        return perfil.tipoPerfil.codigo;
      })
      );
  }, [perfis]);

  useEffect(() => {
    const userCpf = auth.getUser();
    if (userCpf &&auth.isAuthenticated() && !perfis) {
      dispatch(setBuscandoPerfis(true));
      dispatch(getPerfis(userCpf));
    }
  }, [dispatch]);

  useEffect(() => {
    if (perfis) {
      if (perfis.length === 1) {
        dispatch(selecionarTipoPerfil(perfis[0].tipoPerfil.codigo));
        dispatch(selecionarNumeroFamiliar(perfis[0].numeroFamiliar));
        dispatch(selecionarPerfil(perfis[0]));
      } else if (perfis.length > 1 && tiposPerfil().length === 1) {
        dispatch(selecionarTipoPerfil(perfis[0].tipoPerfil.codigo));
      }
    }
  }, [dispatch, perfis, perfil, tiposPerfil]);

  useEffect(() => {
    if (
      auth.isAuthenticated() &&
      perfil &&
      perfil.numeroFamiliar &&
      permiteRemoverFamiliaCadUnico === null
      ) {
      dispatch(
        getPermiteRemoverFamiliaCadUnico({
          cpf: auth.getUser(),
          numeroFamiliar: perfil.numeroFamiliar,
        })
        );
      }
    }, [dispatch, perfil, permiteRemoverFamiliaCadUnico]);

  const entrarGovBr = () => {
    if (!connectionStatus.isOnline) {
      setConnectionError(true);
      return;
    }

    if (!apiStatus.isOnline) {
      setApiError(true);
      return;
    }

    localStorage.removeItem('cadunico/situacaoCadastroFamilia/responseError');

    dispatch(limparPerfil());
    dispatch(limparDadosFamilia());
    dispatch(setLoggingIn(true));
    dispatch(loginGateway('/home'));
    auth.limparStorage();

    if (!popupIntervalId) {
      const intervalId = setInterval(() => {
        if (auth.isAuthenticated() && auth.getUser() && gatewayLogado) {
          // Aguarda SuccessLogin completar o processo
          clearInterval(intervalId);
          setPopupIntervalId(undefined);
          dispatch(setLoggingIn(false));
          // Força reload da página para garantir estado correto
          // window.location.reload();
        } else if (auth.isAuthenticatedClose()) {
          clearInterval(intervalId);
          setPopupIntervalId(undefined);
          dispatch(setLoggingIn(false));
          dispatch(limparAuth());
          auth.limparStorage();
          history.replace('/');
        }
      }, 1000);
      setPopupIntervalId(intervalId);
    }
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const isLogadoGovBr = () => {
    return (auth.isAuthenticated() && auth.getUser() && gatewayLogado);
  };

  const isLogado = () => {
    return auth.isAuthenticated() && auth.getUser();
  };

  const isCarregandoDados = () => {
    return auth.isAuthenticated() && auth.getUser() && !situacaoCadastroFamilia;
  };

  const responseErrorMessage = () => {
    if (!temVersaoMinimaAceitavel) {
      return (
        <Message
          className={styles.msgErro}
          type={'warning'}
          title={
            configuration.isCordova
              ? mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
              : mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB
          }
        />
      );
    }

    if (!localStorage.getItem('cadunico/situacaoCadastroFamilia/responseError')) {
      return <></>;
    }

    try {
      const responseErrorJson = JSON.parse(
        localStorage.getItem('cadunico/situacaoCadastroFamilia/responseError') as string
        );

      let errorType = responseErrorJson.name === 'MinimumVersionWarning' ? 'warning' : 'error';

      return (
        <Message
          className={styles.msgErro}
          type={errorType}
          title={responseErrorJson.message}
        />
        )
      } catch (e) {
        // Se der algum erro no JSON.parse, não mostrar nenhuma mensagem.
        return <></>;
      }
  };

  const aptoPreCadastro = () => {
    return (
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_APTO_A_COMECAR_O_PRE_CADASTRO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_PRAZO_CADASTRO_DECORRIDO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_INICIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO_REJEITADO
    );
  };

  const exibirMensagensSolicitacaoCadastramento = () => {
    return (
      <>
        {responseErrorMessage()}

        {((!FAMILIA_NAO_CADASTRADA) || (FAMILIA_NAO_CADASTRADA && perfil?.temRL && !selecionouSolicitacaoCadastramento)) &&
          <DadosBasicos />
        }

        {  (selecionouSolicitacaoCadastramento && situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario === SituacaoCadastroFamiliaUsuario.USUARIO_APTO_A_COMECAR_O_PRE_CADASTRO ) && (
          <Message
            className={styles.msgErro}
            type="warning"
            title={<>Não foi possível localizar suas informações no Cadastro Único. Em caso de dúvidas você pode procurar o posto do Cadastro Único mais próximo da sua casa para verificar a situação do seu cadastro
              ou para se inscrever no Cadastro Único.
            </>}
           /**  onClick={() => aptoPreCadastro() ? mostrarSelecaoUFCriseRS(history) : mostrarPreCadastro(history)} */
          />
        )}

        {(selecionouSolicitacaoCadastramento && situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario === SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_INICIADO) &&
            <Message
              className={styles.msgErro}
              type="warning"
              title={mensagens.MSG_CAD_UNICO_NAO_CADASTRADO}
              text={<>
              </>}
              /**onClick={() => mostrarPreCadastro(history)}*/
            />
        }

        {selecionouSolicitacaoCadastramento && situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario === SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO &&
            <Message
              className={styles.msgErro}
              type="warning"
              text={` As informações da solicitação de cadastramento de sua família foram inseridas com sucesso. Mas não se esqueça! Para concluir seu cadastro, o(a) Responsável Familiar deve ir até um CRAS ou posto de atendimento do Cadastro Único em até ${calcularTempoRestanteDecursoPrazo(dadosPreFamilia?.dataEnvioCaixa, decursoPrazo)} dias.`}
            />
        }

        {selecionouSolicitacaoCadastramento && situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario === SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO &&
          <Message
            className={styles.msgErro}
            type="warning"
            title={"Solicitação de cadastramento aguardando confirmação. Acesse daqui a um dia útil para verificar se deu tudo certo na sua solicitação de cadastramento."}
          />
        }

        {selecionouSolicitacaoCadastramento && situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario === SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO_REJEITADO &&
          <Message
            className={styles.msgErro}
            type="error"
            text={Mensagens.MSG_NAO_FOI_POSSIVEL_REALIZAR_CADASTRO}/>
        }

        {selecionouSolicitacaoCadastramento && situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario === SituacaoCadastroFamiliaUsuario.USUARIO_COM_PRAZO_CADASTRO_DECORRIDO &&
          <Message
            className={styles.msgErro}
            type="warning"
            title={<>Não foi possível localizar suas informações no Cadastro Único. Em caso de dúvidas você pode procurar o posto do Cadastro Único mais próximo da sua casa para verificar a situação do seu cadastro
              ou para se inscrever no Cadastro Único.
            </>}
          />
        }
      </>
    )
  }

  const cardEntrarGovBr = (
      <Card>
      <BrButton className={styles.botaoGovBr} onClick={() => entrarGovBr()}>
        <i className="fas fa-user"></i>
        Entrar com o gov.br
      </BrButton>
      <div className={styles.textoGovBr}>
        <span style={{ marginBottom: 10 }}>Entrando com o gov.br você acessa:</span>
        <div className={styles.textoGovBrGrid}>
          <ul>
            {/**<li><b>Solicitação de cadastramento</b></li>*/}
            <li><b>Consulta ao formulário</b></li>
            <li>Meus benefícios</li>
            <li>Comprovante de cadastro</li>
            <li>Entre outros serviços</li>
          </ul>
        </div>
      </div>
    </Card>
  );

  const botoesServicoSemLogin = (
    <>
      <Grid item xs={4} md={2}>
        <BotaoServico
          iconClass="fa-map-marked-alt"
          text="Postos de atendimento"
          onClick={() => mostrarPostosAtendimento(history)}
        />
      </Grid>
      <Grid item xs={4} md={2}>
        <BotaoServico
          iconClass="fa-hand-holding-heart"
          text="Programas sociais"
          onClick={() => mostrarProgramasSociais(history)}
        />
      </Grid>
      <Grid item xs={4} md={2}>
        <BotaoServico
          iconClass="fa-check"
          text="Validar comprovante de cadastro"
          onClick={() => mostrarValidacaoComprovante(history)}
          />
      </Grid>
    </>
  )

  const telaInicialNaoLogado = (
    <>
      <img className={styles.logoCadastroUnico} src={logoCadastroUnico} alt="Logo Cadastro Único" />
      {connectionError && <InternetConnectionError onClose={() => setConnectionError(false)} />}

      {apiError && <ApiConnectionError refreshOnClick onClose={() => setApiError(false)} />}

      {!connectionError && !apiError && (
        <>
          {responseErrorMessage()}
          {cardEntrarGovBr}
          <Card>
            <span className={styles.cardTitle}>Serviços sem senha</span>
            <div className={styles.buttonGridWrapper}>
              <Grid container spacing={4}>
                <Grid item xs={4} md={2}>
                  <BotaoServico
                    img={imgConsultaCpf}
                    text="Consulta por CPF"
                    onClick={() => mostrarConsultaCpf(history)}
                  />
                </Grid>
                {botoesServicoSemLogin}
              </Grid>
            </div>
            <hr className={styles.divider} />
            <span className={styles.text}>Ainda não é cadastrado?</span>
            <span className={styles.textLink} onClick={() => history.push('/como-cadastrar')}>
              Saiba como cadastrar sua família
            </span>
            <div className={styles.divLinks}>
              <a
                className={styles.textLink}
                href="https://www.gov.br/mds/pt-br/acoes-e-programas/cadastro-unico"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sobre o Cadastro Único
              </a>
              <a
                className={styles.textLink}
                href="https://www.gov.br/mds/pt-br/acoes-e-programas/cadastro-unico/perguntas-frequentes-cadastro-unico"
                target="_blank"
                rel="noopener noreferrer"
              >
                Perguntas frequentes
              </a>
            </div>
          </Card>
          <AjudaRapida scrollOffset={SCROLL_OFFSET_NAV_FIXED}>
            <div className={styles.textoAjudaRapida}>
              Aqui você encontra as informações da sua família registradas no Cadastro Único
              para Programas Sociais do Governo Federal.
              <br />
              <br />
              <strong>Entrar com o gov.br</strong>
              <br />
              <br />
              Use sua conta do Gov.br para acessar todos os serviços do menu principal do
              aplicativo, como, por exemplo, Consulta ao formulário, Meus benefícios,
              Comprovante de cadastro, entre outras.
              <br />
              <br />
              <strong>Consulta por CPF</strong>
              <br />
              <br />
              Descubra se sua família está cadastrada no Cadastro Único, informando apenas
              do CPF e data de nascimento. Se estiver, você pode acessar os dados com sua
              conta Gov.br.
              <br />
              <br />
              {/* <strong>Consulta simples</strong>
          <br />
          <br />
          Aqui, informando os campos nome completo, data de nascimento, nome da mãe e local de
          cadastro, você tem acesso ao menu com as funcionalidades de Dados resumidos da família,
          Comprovante de cadastro, entre outras. Atenção, para que o sistema identifique a pessoa,
          os dados informados deverão ser exatamente iguais aos dados que estão cadastrados no
          Cadastro Único. Essa consulta apresenta os dados registrados no Sistema de Cadastro
          Único até o dia útil anterior.
          <br />
          <br /> */}
              <strong>Postos de atendimento</strong>
              <br />
              <br />
              Veja os postos de atendimento do Cadastro Único mais próximos da sua casa.
              <br />
              <br />
              <strong>Programas sociais</strong>
              <br />
              <br />
              Conheça os programas sociais do Governo Federal e saiba como participar de cada um.
              <br />
              <br />
              <strong>Validar comprovante de cadastro</strong>
              <br />
              <br />
              Os órgãos responsáveis pelos programas de Governo podem validar o comprovante
              de cadastro da sua família.
            </div>
          </AjudaRapida>
        </>
      )}
    </>
  );

  const getIcon = (type) => {
    switch (type) {
      case 'info': return 'fas fa-info-circle';
      case 'success': return 'fas fa-check-circle';
      case 'warning': return 'fas fa-exclamation-triangle';
      case 'error': return 'fas fa-times-circle';
      case 'question': return 'fas fa-question';
    }
  };

  const telaInicialLogadoGovBr = (
    <>
      {exibirMensagensSolicitacaoCadastramento()}

      {!!perfil?.quantidadePendencias && perfil.quantidadePendencias > 0 && !selecionouSolicitacaoCadastramento && (
        <>
          <Dialog
            open={mostrarModalPendencias}
            onClose={() => dispatch(setMostrarModalPendencias(false))}
          >
            <DialogContent>
              <div className={styles.modalTitle}>
                Olá, {obterNomeDoPerfilComum(perfil)}
              </div>

              <div className={styles.modalContent}>
                <div className={styles.title}>
                  <i className={`${getIcon("warning")} ${styles.icon} ${styles["error"]}`}></i>
                  <div className={styles.subModalTitle}>
                    ATENÇÃO!
                  </div>
                </div>
                <div className={styles.bodyContent}>
                  O cadastro da sua família possui pendências a serem resolvidas no CRAS.
                  <br/>
                  <br/>
                  Para mais informações clique em <strong>Continuar</strong>.
                </div>
              </div>
              <div className={styles.modalFooter}>
                <BrButton
                  className={`${styles.button} ${styles.secondary}`}
                  onClick={() => dispatch(setMostrarModalPendencias(false))}
                >
                  Cancelar
                </BrButton>
                <BrButton
                  className={styles.button}
                  onClick={() => {
                    dispatch(setMostrarModalPendencias(false));
                    mostrarConsultaPendencias(history);
                  }}
                >
                  Continuar
                </BrButton>
              </div>
            </DialogContent>
          </Dialog>
        </>
      )}

      <Card>
        <div className={styles.buttonGridWrapper}>
          <Grid container spacing={4}>
            <Grid item xs={4} md={2}>
              <BotaoServico
                iconClass="fa-bell"
                text="Pendências do cadastro"
                onClick={() => mostrarConsultaPendencias(history)}
                highlight={!selecionouSolicitacaoCadastramento && perfil?.quantidadePendencias > 0 ? 'red' : ''}
                badgeCount={!selecionouSolicitacaoCadastramento ? perfil?.quantidadePendencias : ''}
                disabled={selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)}
              />
            </Grid>

            <Grid item xs={4} md={2}>
              <BotaoServico
                iconClass="fa-scroll"
                text="Consulta ao formulário"
                onClick={() => mostrarConsultaCompleta(history)}
                disabled={selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)}
                />
            </Grid>
            <Grid item xs={4} md={2}>
              <BotaoServico
                iconClass="fa-hands-helping"
                text="Meus benefícios"
                onClick={() => mostrarMeusBeneficios(history)}
                disabled={selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)}
              />
            </Grid>
            <Grid item xs={4} md={2}>
              <BotaoServico
                iconClass="fas fa-search"
                text="Consulta de renda CNIS"
                onClick={() => mostrarConsultaRenda(history)}
                disabled={selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)}
              />
            </Grid>
            <Grid item xs={4} md={2}>
              <BotaoServico
                iconClass="fas fa-book-reader"
                text="Consulta de escolaridade atualizada"
                onClick={() => mostrarConsultaEscolaridade(history)}
                disabled={selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)}
              />
            </Grid>
            {permiteRemoverFamiliaCadUnico && (
              <Grid item xs={4} md={2}>
                <BotaoServico
                  iconClass={`fa-user-slash ${styles.redIcon}`}
                  text="Cancele o seu cadastro"
                  onClick={() => mostrarExclusaoCadastralTutorial(history, false)}
                />
              </Grid>
            )}
            <Grid item xs={4} md={2}>
              <BotaoServico
                iconClass="fa-receipt"
                text="Comprovante de cadastro"
                onClick={() => mostrarComprovante(history)}
                disabled={selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)}
              />
            </Grid>

            {botoesServicoSemLogin}
            
            {perfil?.tipoPerfil?.codigo === TipoPerfil.RESPONSAVEL_FAMILIAR && perfil?.tipoEstadoCadastralFamilia?.codigo === 3 && !rfTemIndicativoObito &&
              <Grid item xs={4} md={2}>
                <BotaoServico
                  iconClass="fa-wallet"
                  text="Carteira de documentos"
                  onClick={() => mostrarCarteiraDocumentos(history)}
                />
              </Grid>
            }
          </Grid>
        </div>
      </Card>

      <AjudaRapida scrollOffset={SCROLL_OFFSET_NAV_FIXED}>
        <div className={styles.textoAjudaRapida}>
          O aplicativo Cadastro Único permite consultar as informações de sua família que estão
          registradas no Cadastro Único para Programas Sociais do Governo Federal.
          <br />
          <br />

          <strong>Pendências do cadastro</strong>
          <br />
          <br />
          Aqui você pode conferir se há pendências no seu Cadastro, como dados obrigatórios
          não preenchidos ou CPF com situação irregular.
          <br />
          Vá até um CRAS ou posto de atendimento para atualizar seus dados no Cadastro e
          evitar bloqueio nos benefícios.
          <br />
          <br />

          <strong>Consulta ao formulário</strong>
          <br />
          <br />
          Aqui você visualiza as informações completas do seu cadastro e de sua
          família que estão no Cadastro Único.

          <br />
          <br />

          <strong>Meus Benefícios</strong>
          <br />
          <br />
          Aqui você visualiza os benefícios que sua família recebe.
          <br />
          <br />

          <strong>Consulta de renda CNIS</strong>
          <br />
          <br />
          Aqui você pode ver a renda da sua família encontrada nos registros do
          Governo Federal, no Cadastro Nacional de Informações Sociais (CNIS), e ver a
          renda atualizada no Cadastro Único.
          <br />
          <br />

          <strong>Consulta de escolaridade atualizada</strong>
          <br />
          <br />
          Aqui você pode ver as informações sobre crianças e jovens registradas no
          Sistema Presença do Ministério da Educação (MEC), usados para atualizar as
          informações cadastrais de pessoas entre 04 e 17 anos.
          <br />
          Esse sistema é usado para acompanhar a frequência escolar e atualizar os
          dados de estudantes beneficiários do Bolsa Família.
          <br />
          <br />

          <strong>Cancele o seu cadastro</strong>
          <br />
          <br />
          Aqui o Responsável Familiar poderá solicitar o cancelamento do seu cadastro.
          Atenção: disponível apenas para cadastros com somente uma pessoa.
          <br />
          <br />

          <strong>Comprovante de cadastro</strong>
          <br />
          <br />
          Aqui você pode emitir um comprovante de que você está no Cadastro Único.
          <br />
          <br />

          <strong>Postos de atendimento</strong>
          <br />
          <br />
          Consulte aqui os postos de atendimento do Cadastro Único que ficam mais
          próximos de onde você está.
          <br />
          <br />

          <strong>Programas sociais</strong>
          <br />
          <br />
          Aqui você pode conhecer os programas sociais do Governo Federal e saber se você tem direito a algum deles.
          <br />
          <br />

          <strong>Validar comprovante de cadastro</strong>
          <br />
          <br />
          Os órgãos responsáveis pelos programas de Governo podem validar o comprovante de cadastro da sua família.
          <br />
          <br />

          <strong>Estado cadastral</strong>
          <br />
          <br />
          Indica a situação do registro da família ou da pessoa no Cadastro Único.
          <br />
          <br />
          <strong>Estado cadastral - Em cadastramento</strong>
          <br />
          <br />
          Quando os dados ainda estão incompletos. O responsável familiar (RF) ou o
          representante legal (RL) deve ir ao CRAS ou posto de atendimento para completar o
          cadastro.
          <br />
          <br />
          <strong>Estado cadastral - Aguardando CPF</strong>
          <br />
          <br />
          Os dados da pessoa estão completos, faltando apenas o cadastro do CPF
          (Cadastro de Pessoas Físicas), que é um documento obrigatório no Cadastro Único.
          <br />
          <br />
          <strong>Estado cadastral - Cadastrado</strong>
          <br />
          <br />
          Quando o cadastro da pessoa ou família está completo.
          <br />
          <br />
          <strong>Estado cadastral - Sem registro civil</strong>
          <br />
          <br />
          Indica o cadastro de uma pessoa que não teve o seu nascimento registrado em
          cartório de registro civil. Quando esse estado for atribuído para uma família,
          significa que todos os integrantes da família não possuem registro civil de nascimento.
        </div>
      </AjudaRapida>
    </>
  );

  if (loggingIn) {
    return (
        <LoadingGlobal message='Entrando...' />
    );
  }

  return (
    <MainContainer
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      navHideArrow={!isLogado()}
      userNav={isLogado()}
      padraoInicial={!isLogado()}
      navFixed={isLogado()}
      stoppedTitle={true}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}
    >
      <div className={`${styles.container} ${isLogado() ? styles.margin : ''}`}>

        {!isLogado() && (telaInicialNaoLogado)}

        {isLogado() && (telaInicialLogadoGovBr)}

        {isCarregandoDados() && (<Card>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            minHeight: '200px'
          }}>
            <div style={{ marginBottom: '20px' }}>Carregando suas informações...</div>
            <LoadingGlobal />
          </div>
        </Card>)}
      </div>
      {!connectionError && !apiError && (
        <div className={styles.moreOptionsWrapper}>
        <Accordion id="more-options" title="Mais opções" className={styles.moreOptions} scroll>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Card className={styles.moreOptionsCard}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <div className={styles.moreOptionsLeftPanel}>
                      <div className={styles.moreOptionsTitulo}>
                        Política de privacidade e termos de uso
                      </div>
                      <BrButton className={styles.moreOptionsButton} onClick={() => mostrarTermoDeUso(history)}>
                        Termos de uso
                      </BrButton>
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <div className={styles.moreOptionsLegenda}>
                      Saiba como este aplicativo usa seus dados seguindo a LGPD - lei geral de
                      proteção de dados.
                    </div>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </Accordion>
        </div>
      )}
    </MainContainer>
  );
};

export default Home;
